if (!customElements.get('slider-testimonials')) {
  class SliderTestimonials extends HTMLElement {
    constructor() {
      super();

      this.swiperInstance = null;
      this.selectors = {
        clip: '.js-slider-clip',
        slide: '.js-slide',
      };
    }

    connectedCallback() {
      this.config = {
        speed: 500,
        spaceBetween: 20,
        breakpoints: {
          0: {
            slidesPerView: 1.35,
            spaceBetween: 16,
          },
          767: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          1023: {
            slidesPerView: 3,
          },
          1299: {
            slidesPerView: 4,
          },
        },
      };

      this.clip = this.querySelector(this.selectors.clip);

      this.initSwiper();
    }

    disconnectedCallback() {
      this.destroySwiper();
    }

    initSwiper() {
      if (!this.clip) return;

      this.swiperInstance = new Swiper(this.clip, this.config);
    }

    destroySwiper() {
      this.swiperInstance?.destroy();
    }
  }

  customElements.define('slider-testimonials', SliderTestimonials);
}
